import React, { Component } from 'react'
import PropTypes from 'prop-types'
import accountUtils from '../../../../utils/account/accountUtils'
import OnboardingSearchBar from './OnboardingSearchBar'
import OnboardingListItem from './OnboardingListItem'

export default class InvitedPersonsWrapper extends Component {
  static propTypes = {
    data: PropTypes.any.isRequired,
    title: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      searchFilter: '',
    }

    this.onSearch = (searchFilter) => {
      this.setState({searchFilter})
    }
  }

  render() {
    const { data, title } = this.props
    const { searchFilter } = this.state

    const filteredData = data.filter(
      item =>
        accountUtils
          .getFullName(item)
          .toLowerCase()
          .indexOf(searchFilter.toLowerCase()) !== -1,
    )

    return (
      <div>
        <div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <h6 style={{marginBottom: 0, display: 'inline-block'}}>{title}</h6>
            {!!data.length && <OnboardingSearchBar onChange={this.onSearch}/>}
          </div>
          <div className="card invite-list"
               style={{ boxShadow: (filteredData.length > 3 ? '0px -10px 10px -10px #000 inset' : 'none')}}
          >
            {filteredData.length ?
              filteredData.map(item => (
              <OnboardingListItem key={item._id} id={item._id} content={accountUtils.getFullName(item)} />
            ))
            :
              data.length ?
                <div className="text-center"> No Results </div>
              :
                <div className="text-center"> When members join, their info will show here.</div>
            }
          </div>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/AdminDashboard/components/SignedUpPersonsWrapper.js